<template lang="html">
  <BaseLoading :spinning="coachesLoading">
    <div class="events-list-wrap coach-table-wrap create-profile-wrapper">
      <div class="container">
        <div class="events-content-wrap">
          <div class="head">
            <div class="head-title">
              <h2 class="form-title">Coaching Staff</h2>
            </div>
            <BaseButton
              type="primary"
              class="add-event-btn"
              icon="plus"
              @click="newCoach"
              >Add New Coach</BaseButton
            >
          </div>
          <BaseTable
            :columns="columns"
            :data="coaches"
            :pagination="{}"
            :loading="coachesLoading"
            :show-zero="coachesMeta.total === 0"
          />
        </div>
      </div>
    </div>
  </BaseLoading>
</template>

<script>
import { mapGetters } from "vuex";
import { CLUB_COACH_INDEX_TABLE } from "@/utils/columns";
import { Base } from "@/models";

const COACH_STORE_KEY = "coachStore";

export default {
  data() {
    return {
      currentPage: 1
    };
  },
  mounted() {
    this.dispatcher();
  },
  computed: {
    localStorage() {
      return localStorage;
    },
    columns() {
      return [
        ...CLUB_COACH_INDEX_TABLE,
        {
          title: "Actions",
          dataIndex: "actions",
          width: 200,
          customRender: (_text, rowData, _index) => {
            return (
              <div class="table-actions-wrapper">
                <a on-click={event => this.viewAction(rowData.key)}>View</a>
                <a
                  on-click={event => this.editAction(rowData.key)}
                  style={
                    String(rowData.key) ===
                    String(this.localStorage["profile-id"])
                      ? "display: none"
                      : ""
                  }
                >
                  Edit
                </a>
                <a-popconfirm
                  title="Sure you want to delete this coach?"
                  on-confirm={event => this.deleteEvent(rowData.key)}
                  ok-text="Yes"
                  cancel-text="No"
                  style={
                    String(rowData.key) ===
                    String(this.localStorage["profile-id"])
                      ? "display: none"
                      : ""
                  }
                >
                  <a-button type="danger" icon="delete">
                    Delete
                  </a-button>
                </a-popconfirm>
              </div>
            );
          }
        }
      ];
    },
    paginationOptions() {
      return {
        total: this.coachesMeta.total || 10,
        current: this.currentPage || 1,
        simple: true
      };
    },
    ...mapGetters({
      coaches: `${COACH_STORE_KEY}/coaches`,
      coachesLoading: `${COACH_STORE_KEY}/coachesLoading`,
      coachesMeta: `${COACH_STORE_KEY}/coachesMeta`
    }),
    profileId() {
      return Base.profileId();
    }
  },
  methods: {
    async deleteEvent(id) {
      await this.$store.dispatch(`${COACH_STORE_KEY}/deleteClubCoach`, {
        slug: "clubcoach",
        coachId: id
      });
      await this.$store.dispatch(`${COACH_STORE_KEY}/removeCoachFromList`, id);
    },
    viewAction(id) {
      this.$router.push(
        `/${this.profileId}/club/coaching_staffs/${id}/details`
      );
    },
    newCoach() {
      this.$router.push(`/${this.profileId}/club/coaching_staffs/new`);
    },
    editAction(id) {
      this.$router.push(`/${this.profileId}/club/coaching_staffs/${id}/edit`);
    },
    async handleTableChange(pagination) {
      await this.dispatcher(pagination.current);
    },
    dispatcher(page = 1) {
      this.currentPage = page;
      this.$store.dispatch(`${COACH_STORE_KEY}/getCoaches`, {
        sort: "createdAt",
        resourceType: "clubcoach",
        clubId: localStorage["club-id"],
        ...this.searchQuery
      });
    }
  }
};
</script>

<style lang="scss">
.coach-table-wrap {
  .events-content-wrap {
    .head {
      .head-title {
        padding-bottom: 30px;
      }
    }
  }
  .bordered-table {
    background: #ffffff;
  }
}
</style>
